// extracted by mini-css-extract-plugin
export const authorList = "ReviewCard-module--authorList--3dLSi";
export const ecClass = "ReviewCard-module--ecClass--S8B_N";